import { render } from "./AsTypesAuth.vue?vue&type=template&id=e331ed1a&scoped=true&ts=true"
import script from "./AsTypesAuth.vue?vue&type=script&lang=ts"
export * from "./AsTypesAuth.vue?vue&type=script&lang=ts"

import "./AsTypesAuth.vue?vue&type=style&index=0&id=e331ed1a&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e331ed1a"]])

export default __exports__